import React from "react";
import { useParams } from "react-router-dom";
import { storage } from "../../utils";
import styleCodes, { isBand } from "../../utils/styleCodes";
import _ from "lodash";
import Bands from "../products/productDetails/Bands";
import ProductDetailPage from "../products/productDetails/ProductDetailPage";
import Charms from "../products/productDetails/Charms";

export default function Product(props) {
  const { ProductStyleCode, ProductStyleCodeSecondPart } = useParams();
  const RecentlyViewed = JSON.parse(
    storage.getSessionStorageItem("hsRecentlyViewedProducts")
  );
  const isMill = () => {
    return _.includes(styleCodes.millProducts, ProductStyleCode);
  };
  const band = isBand(ProductStyleCode);
  const jewelryProductGroup =
    ProductStyleCode === "CIR"
      ? "Circles"
      : ProductStyleCode === "WRB"
      ? "Ring Blanks"
      : ProductStyleCode === "WAS"
      ? "Washers"
      : ProductStyleCode === "CHM"
      ? "Charms"
      : props.location.state
      ? props.location.state.productGroup
      : "Jewelry";
  return band === true &&
    props.location.state.mtoConfiguratorProduct === true ? (
    <Bands
      ProductStyleCode={ProductStyleCode}
      ProductGroup="Bands"
      isMill={false}
      RecentlyViewed={RecentlyViewed}
      {...props}
    />
  ) : ProductStyleCode === "CHM" ? (
    <Charms
      ProductStyleCode={ProductStyleCode}
      ProductGroup="Charms"
      isMill={false}
      RecentlyViewed={RecentlyViewed}
      {...props}
    />
  ) : isMill() === true ? (
    _.includes(
      [
        "GR",
        "SD",
        "SDC",
        "SR",
        "SRB",
        "FLX",
        "SDB",
        "ALL",
        "FS",
        "BUL",
        "DSK",
        "ML",
        "AE",
        "LW",
        "SWD",
        "SWR",
      ],
      ProductStyleCode
    ) ? (
      <ProductDetailPage
        ProductStyleCode={ProductStyleCode}
        ProductGroup="Mill"
        isMill={true}
        RecentlyViewed={RecentlyViewed}
        {...props}
      />
    ) : (
      <ProductDetailPage
        ProductStyleCode={ProductStyleCode}
        ProductGroup="WireTubing"
        RecentlyViewed={RecentlyViewed}
        isMill={true}
        {...props}
      />
    )
  ) : (
    <ProductDetailPage
      ProductStyleCode={
        ProductStyleCodeSecondPart
          ? `${ProductStyleCode}/${ProductStyleCodeSecondPart}`
          : ProductStyleCode
      }
      ProductGroup={jewelryProductGroup}
      RecentlyViewed={RecentlyViewed}
      isMill={false}
      {...props}
    />
  );
}
